import { useContext } from "react";

import { ArrowsListennerHandler } from "../contexts/ArrowsListennerHandler";

export function useArrowsListennerHandler() {
  const context = useContext(ArrowsListennerHandler);

  return context;
}
